export default __webpack_public_path__ + "static/media/basketIcon.98bd60b3.svg";